import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuizAttemptData } from 'quiz-types';

interface GRADER_STATE_TYPE {
  email: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  attempt: QuizAttemptData | undefined;
}

const INITIAL_STATE: GRADER_STATE_TYPE = {
  email: undefined,
  first_name: undefined,
  last_name: undefined,
  attempt: undefined,
};

const graderSlice = createSlice({
  name: 'grader',
  initialState: INITIAL_STATE,
  reducers: {
    setAttemptUserEmail(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.email = action.payload;
    },
    setAttemptUserFirstName(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.first_name = action.payload;
    },
    setAttemptUserLastName(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.last_name = action.payload;
    },
    setAttemptGradingData(
      state: GRADER_STATE_TYPE,
      action: PayloadAction<QuizAttemptData | undefined>,
    ) {
      state.attempt = action.payload;
    },
    resetGraderSlice(state: GRADER_STATE_TYPE) {
      state.email = INITIAL_STATE.email;
      state.first_name = INITIAL_STATE.first_name;
      state.last_name = INITIAL_STATE.last_name;
      state.attempt = INITIAL_STATE.attempt;
    },
  },
});

export const {
  setAttemptUserEmail,
  setAttemptUserFirstName,
  setAttemptUserLastName,
  setAttemptGradingData,
  resetGraderSlice,
} = graderSlice.actions;
export default graderSlice.reducer;
